import orderingApi from '../api/ordering';
import {
  GET_REPORT_TEMPLATE_BEGIN,
  GET_REPORT_TEMPLATE_FAILURE,
  GET_REPORT_TEMPLATE_SUCCESS,
  SET_REPORT_TEMPLATE,
  GET_REPORT_BEGIN,
  GET_REPORT_FAILURE,
  GET_REPORT_SUCCESS,
  SET_REPORT,
  SAVE_REPORT_BEGIN,
  SAVE_REPORT_SUCCESS,
  SAVE_REPORT_FAILURE,
  SET_CREATED_REPORT_ID,
  SET_CREATED_REPORT_SUPPLIER,
  SET_CREATED_REPORT_MONTH,
  SET_CREATED_REPORT_ORDERPERIOD,
  SET_AVAILABLE_SUPPLIERS,
  OPEN_ORDERING_TABLE_IN_WINDOW,
  CLOSE_ORDERING_TABLE_WINDOW,
} from './types';


function naturalCompare(a, b) {
  var ax = [], bx = [];

  a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || '']) });
  b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || '']) });
  
  while(ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if(nn) return nn;
  }

  return ax.length - bx.length;
}

function sortingFunc(el1, el2) {
  let a = String(el1).trim().toLowerCase().split(' ').join('0');
  let b = String(el2).trim().toLowerCase().split(' ').join('0');
  return naturalCompare(b, a);
}

export default {
  namespaced: true,
  state: {
    availableSuppliers: [],
    reportTemplate: null,
    gettingReportTemplate: false,
    gettingReportTemplateCompleted: false,
    gettingReportTemplateError: false,
    createdReportId: null,
    createdReportSupplier: null,
    createdReportMonth: null,
    createdReportOrderPeriod: null,
    report: null,
    gettingReport: false,
    gettingReportCompleted: false,
    gettingReportError: false,
    savingReport: false,
    savingReportCompleted: false,
    savingReportError: false,
    orderingReportTableWindowOpen: false,
    excelExportOrderingData: [],
  },
  actions: {
    getReportTemplate({ commit }, {supplier, orderPeriod, year, month}) {
      commit(GET_REPORT_TEMPLATE_BEGIN);
      return orderingApi.getReportTemplate(supplier, orderPeriod, year, month)
        .then(({ data }) => {
          if (data['error'] === true) {
            commit(GET_REPORT_TEMPLATE_FAILURE);
            return;
          }
          commit(SET_CREATED_REPORT_ID, data['report_id'])
          commit(SET_CREATED_REPORT_SUPPLIER, data['supplier'])
          commit(SET_REPORT_TEMPLATE, data['data'])
          commit(SET_CREATED_REPORT_MONTH, month)
          commit(SET_CREATED_REPORT_ORDERPERIOD, orderPeriod)
        })
        .then(() => commit(GET_REPORT_TEMPLATE_SUCCESS))
        .catch(() => commit(GET_REPORT_TEMPLATE_FAILURE));
    },
    getOrderingReport({ commit }, reportEntityId) {
      commit(GET_REPORT_BEGIN);
      return orderingApi.getReport(reportEntityId)
        .then(({ data }) => {
          if (data['error'] === true) {
            commit(GET_REPORT_FAILURE);
            return;
          }
          commit(SET_REPORT, data['data'])
        })
        .then(() => commit(GET_REPORT_SUCCESS))
        .catch(() => commit(GET_REPORT_FAILURE));
    },
    saveOrderingReport({ commit }, {reportEntityId, changes}) {
      commit(SAVE_REPORT_BEGIN);
      return orderingApi.saveReport(reportEntityId, changes)
        .then(({ data }) => {
          if (data['error'] === true) {
            commit(SAVE_REPORT_FAILURE);
            return;
          }
        })
        .then(() => commit(SAVE_REPORT_SUCCESS))
        .catch(() => commit(SAVE_REPORT_FAILURE));
    },
    getAvailableSuppliers({ commit }) {
      return orderingApi.getAvailableSuppliers()
        .then(({ data }) => {
          commit(SET_AVAILABLE_SUPPLIERS, data['data'])
        });
    },
    openOrderingTableInWindow({ commit }) {
      commit(OPEN_ORDERING_TABLE_IN_WINDOW);
    },
    closeOrderingTableWindow({ commit }) {
      commit(CLOSE_ORDERING_TABLE_WINDOW);
    },
  },
  mutations: {
    [GET_REPORT_TEMPLATE_BEGIN](state) {
      state.gettingReportTemplate = true;
      state.gettingReportTemplateError = false;
    },
    [GET_REPORT_TEMPLATE_FAILURE](state) {
      state.gettingReportTemplate = false;
      state.gettingReportTemplateCompleted = false;
      state.gettingReportTemplateError = true;
    },
    [GET_REPORT_TEMPLATE_SUCCESS](state) {
      state.gettingReportTemplate = false;
      state.gettingReportTemplateCompleted = true;
      state.gettingReportTemplateError = false;
    },
    [SET_REPORT_TEMPLATE](state, data) {
      state.reportTemplate = data.sort(function(el1, el2) {
        const product1NameNormalized = el1['Product Name'].trim().toLowerCase();
        const product2NameNormalized = el2['Product Name'].trim().toLowerCase();
        const char1 = product1NameNormalized.split(' ')[0][0];
        const char2 = product2NameNormalized.split(' ')[0][0];
        if (char1 != char2) {
          return char1 > char2 ? 1 : -1;
        }
        return product1NameNormalized.localeCompare(product2NameNormalized);
      });

      state.excelExportOrderingData = state.reportTemplate.map(detailed => ({
        'Product ID': detailed.ProductID,
        'Name': detailed['Product Name'],
        'Description': detailed['Product Description'],
        'Barcode': detailed.Barcode,
        'Last Sold Date': detailed['LastSoldDate'],
        'Last 3 months sales': detailed.Last3MonthsSales,
        'Last order period sales': detailed.LastOrderPeriodSales,
        'This order period last year sales':  detailed.OrderPeriodLastYearSales,
        'Actual order': detailed.ActualOrder,
      }))
    },
    [SET_CREATED_REPORT_ID](state, reportId) {
      state.createdReportId = reportId;
    },
    [SET_CREATED_REPORT_SUPPLIER](state, supplier) {
      state.createdReportSupplier = supplier;
    },
    [SET_CREATED_REPORT_MONTH](state, month) {
      state.createdReportMonth = month;
    },
    [SET_CREATED_REPORT_ORDERPERIOD](state, orderPeriod) {
      state.createdReportOrderPeriod = orderPeriod;
    },
    [GET_REPORT_BEGIN](state) {
      state.gettingReport = true;
      state.gettingReportError = false;
    },
    [GET_REPORT_FAILURE](state) {
      state.gettingReport = false;
      state.gettingReportCompleted = false;
      state.gettingReportError = true;
    },
    [GET_REPORT_SUCCESS](state) {
      state.gettingReport = false;
      state.gettingReportCompleted = true;
      state.gettingReportError = false;
    },
    [SET_REPORT](state, data) {
      state.report = data;
    },
    [SAVE_REPORT_BEGIN](state) {
      state.savingReport = true;
      state.savingReportError = false;
    },
    [SAVE_REPORT_FAILURE](state) {
      state.savingReport = false;
      state.savingReportCompleted = false;
      state.savingReportError = true;
    },
    [SAVE_REPORT_SUCCESS](state) {
      state.savingReport = false;
      state.savingReportCompleted = true;
      state.savingReportError = false;
    },
    [SET_AVAILABLE_SUPPLIERS](state, data) {
      data.sort(sortingFunc);
      data.reverse();
      state.availableSuppliers = data;
    },
    [OPEN_ORDERING_TABLE_IN_WINDOW](state) {
      state.orderingReportTableWindowOpen = true;
    },
    [CLOSE_ORDERING_TABLE_WINDOW](state) {
      state.orderingReportTableWindowOpen = false;
    },
  },
};
 



// WEBPACK FOOTER //
// ./src/store/ordering.js